import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  calendarEvents,
  getListingDailyPrices,
  getListingUsgs,
  getListingWeather,
  getRandomListings,
  onBookmark,
  transactionLineItems,
} from '../../util/api';
import * as log from '../../util/log';
import { convertListingsDataToCardModel, denormalisedResponseEntities } from '../../util/data';
import { datesBetweenDays, findNextBoundary, monthIdString } from '../../util/dates';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import moment from 'moment';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

export const FETCH_LISTINGS_OF_LAST_BOOKINGS_REQUEST =
  'app/ListingPage/FETCH_LISTINGS_OF_LAST_BOOKINGS_REQUEST';
export const FETCH_LISTINGS_OF_LAST_BOOKINGS_SUCCESS =
  'app/ListingPage/FETCH_LISTINGS_OF_LAST_BOOKINGS_SUCCESS';
export const FETCH_LISTINGS_OF_LAST_BOOKINGS_ERROR =
  'app/ListingPage/FETCH_LISTINGS_OF_LAST_BOOKINGS_ERROR';

export const UPDATE_BOOKMARK_REQUEST = 'app/ListingPage/UPDATE_BOOKMARK_REQUEST';
export const UPDATE_BOOKMARK_SUCCESS = 'app/ListingPage/UPDATE_BOOKMARK_SUCCESS';
export const UPDATE_BOOKMARK_ERROR = 'app/ListingPage/UPDATE_BOOKMARK_ERROR';

export const FETCH_DAILY_PRICES_REQUEST = 'app/ListingPage/FETCH_DAILY_PRICES_REQUEST';
export const FETCH_DAILY_PRICES_SUCCESS = 'app/ListingPage/FETCH_DAILY_PRICES_SUCCESS';
export const FETCH_DAILY_PRICES_ERROR = 'app/ListingPage/FETCH_DAILY_PRICES_ERROR';

export const FETCH_CALENDAR_SLOTS = 'app/ListingPage/FETCH_CALENDAR_SLOTS';

export const FORMAT_TIME_SLOTS = 'app/ListingPage/FORMAT_TIME_SLOTS';

export const FETCH_LISTING_USGS_REQUEST = 'app/ListingPage/FETCH_LISTING_USGS_REQUEST';
export const FETCH_LISTING_USGS_SUCCESS = 'app/ListingPage/FETCH_LISTING_USGS_SUCCESS';
export const FETCH_LISTING_USGS_ERROR = 'app/ListingPage/FETCH_LISTING_USGS_ERROR';

export const FETCH_LISTING_WEATHER_DATA_REQUEST =
  'app/ListingPage/FETCH_LISTING_WEATHER_DATA_REQUEST';
export const FETCH_LISTING_WEATHER_DATA_SUCCESS =
  'app/ListingPage/FETCH_LISTING_WEATHER_DATA_SUCCESS';
export const FETCH_LISTING_WEATHER_DATA_ERROR = 'app/ListingPage/FETCH_LISTING_WEATHER_DATA_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';
// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,
  fetchListingsOfLastBookingsInProgress: false,
  fetchListingsOfLastBookingsError: null,
  listingsOfLastBookings: [],
  updateBookmarkInProgress: false,
  updateBookmarkError: null,
  dailyPrices: [],
  calendarSlots: [],
  availableSlots: [],
  listingUsgs: null,
  fetchListingUsgsInProgress: true,
  fetchListingUsgsError: null,
  weatherData: null,
  fetchWeatherDataInProgress: true,
  fetchWeatherDataError: null,
  fetchAvailableSlotsInProgress: true,
  fetchAvailableSlotsError: null,
  reviews: [],
  fetchReviewsError: null,
  fetchReviewsInProgress: false,
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return {
        ...state,
        monthlyTimeSlots,
        fetchAvailableSlotsInProgress: true,
        fetchAvailableSlotsError: null,
      };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots, fetchAvailableSlotsError: payload.error };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };

    case FETCH_LISTINGS_OF_LAST_BOOKINGS_REQUEST:
      return {
        ...state,
        fetchListingsOfLastBookingsInProgress: true,
        fetchListingsOfLastBookingsError: null,
      };
    case FETCH_LISTINGS_OF_LAST_BOOKINGS_SUCCESS: {
      const convertListingsOfLastBookingsToCardModel = convertListingsDataToCardModel(payload);
      return {
        ...state,
        fetchListingsOfLastBookingsInProgress: false,
        listingsOfLastBookings: convertListingsOfLastBookingsToCardModel,
      };
    }
    case FETCH_LISTINGS_OF_LAST_BOOKINGS_ERROR:
      return {
        ...state,
        fetchListingsOfLastBookingsInProgress: false,
        fetchListingsOfLastBookingsError: payload,
      };

    case UPDATE_BOOKMARK_REQUEST:
      return { ...state, updateBookmarkInProgress: true, updateBookmarkError: null };
    case UPDATE_BOOKMARK_SUCCESS:
      return { ...state, updateBookmarkInProgress: false };
    case UPDATE_BOOKMARK_ERROR:
      return { ...state, updateBookmarkInProgress: false, updateBookmarkError: payload };
    case FETCH_DAILY_PRICES_SUCCESS: {
      const { dailyPrices } = payload;
      return { ...state, dailyPrices };
    }
    case FETCH_CALENDAR_SLOTS: {
      const { calendarSlots } = payload;

      return {
        ...state,
        calendarSlots: state.calendarSlots.concat(calendarSlots),
        fetchAvailableSlotsInProgress: false,
      };
    }

    case FORMAT_TIME_SLOTS: {
      const { monthlyTimeSlots, calendarSlots } = state;
      const monthlyTimeSlotsKeys = Object.keys(monthlyTimeSlots || {});

      const availabities = monthlyTimeSlotsKeys
        ?.map(key => {
          return monthlyTimeSlots[key]?.timeSlots?.data?.data;
        })
        ?.flatMap(item => item)
        .map(timeSlot => {
          const attributes = timeSlot?.attributes;
          const betweenDays = datesBetweenDays(
            timeSlot?.attributes?.start,
            timeSlot?.attributes?.end
          );
          const availabilityPlan = betweenDays.map(day => {
            return { start: day, seats: attributes.seats };
          });
          return availabilityPlan;
        })
        .flatMap(plan => plan)
        .filter(avail => {
          const slot = calendarSlots.find(item => {
            return (
              moment(item.start.dateTime).format('YYYY-MM-DD') ===
              moment(avail.start).format('YYYY-MM-DD')
            );
          });

          return !slot ? true : slot && slot.creator.application === 'rarewaters-stribe';
        });

      return {
        ...state,
        availableSlots: availabities,
        fetchAvailableSlotsError: null,
      };
    }

    case FETCH_LISTING_USGS_REQUEST:
      return { ...state, fetchListingUsgsInProgress: true, fetchListingUsgsError: null };
    case FETCH_LISTING_USGS_SUCCESS:
      return { ...state, listingUsgs: payload, fetchListingUsgsInProgress: false };
    case FETCH_LISTING_USGS_ERROR:
      return { ...state, fetchListingUsgsError: payload, fetchListingUsgsInProgress: false };

    case FETCH_LISTING_WEATHER_DATA_REQUEST:
      return { ...state, fetchWeatherDataInProgress: true, fetchWeatherDataError: null };
    case FETCH_LISTING_WEATHER_DATA_SUCCESS:
      return { ...state, weatherData: payload, fetchWeatherDataInProgress: false };
    case FETCH_LISTING_WEATHER_DATA_ERROR:
      return { ...state, fetchWeatherDataError: payload, fetchWeatherDataInProgress: false };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null, fetchReviewsInProgress: true };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload, fetchReviewsInProgress: false };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload, fetchReviewsInProgress: false };

    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const fetchListingsOfLastBookingsRequest = () => ({
  type: FETCH_LISTINGS_OF_LAST_BOOKINGS_REQUEST,
});
export const fetchListingsOfLastBookingsSuccess = listings => ({
  type: FETCH_LISTINGS_OF_LAST_BOOKINGS_SUCCESS,
  payload: listings,
});
export const fetchListingsOfLastBookingsError = error => ({
  type: FETCH_LISTINGS_OF_LAST_BOOKINGS_ERROR,
  error: true,
  payload: error,
});

export const updateBookmarkRequest = () => ({ type: UPDATE_BOOKMARK_REQUEST });
export const updateBookmarkSuccess = () => ({ type: UPDATE_BOOKMARK_SUCCESS });
export const updateBookmarkError = e => ({ type: UPDATE_BOOKMARK_ERROR, error: true, payload: e });

export const fetchDailyPricesSuccess = payload => ({ type: FETCH_DAILY_PRICES_SUCCESS, payload });

export const fetchCalendarSlots = payload => ({ type: FETCH_CALENDAR_SLOTS, payload });
export const formatTimeSlots = () => ({ type: FORMAT_TIME_SLOTS });

export const fetchListingUsgsRequest = () => ({ type: FETCH_LISTING_USGS_REQUEST });
export const fetchListingUsgsSuccess = payload => ({ type: FETCH_LISTING_USGS_SUCCESS, payload });
export const fetchListingUsgsError = error => ({ type: FETCH_LISTING_USGS_ERROR, payload: error });

export const fetchWeatherDataRequest = () => ({ type: FETCH_LISTING_WEATHER_DATA_REQUEST });
export const fetchWeatherDataSuccess = payload => ({
  type: FETCH_LISTING_WEATHER_DATA_SUCCESS,
  payload,
});
export const fetchWeatherDataError = error => ({
  type: FETCH_LISTING_WEATHER_DATA_ERROR,
  payload: error,
});
// ================ Thunks ================ //

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());

  return sdk.reviews
    .query({
      listingId: listingId.uuid,
      state: 'public',
      include: ['author', 'subject'],
    })
    .then(newReviews => dispatch(fetchReviewsSuccess(denormalisedResponseEntities(newReviews))))
    .catch(error => dispatch(fetchReviewsError(storableError(error))));
};

export const calendarSlotsRequest = (userId, listingId, start, end) => (
  dispatch,
  getState,
  sdk
) => {
  return calendarEvents({ userId, listingId, start, end }).then(res => {
    dispatch(fetchCalendarSlots({ calendarSlots: res.data }));
  });
};

export const fetchDailyPrices = (listingId, start, end) => (dispatch, getState, sdk) => {
  return getListingDailyPrices({ listingId, start, end })
    .then(response => {
      const stateDailyPrices = getState().ListingPage.dailyPrices;
      const dailyPrices = response.dailyPrices;

      const dates = new Set(stateDailyPrices.map(dailyPrice => dailyPrice?.date));
      const mergedPrices = stateDailyPrices.concat(
        dailyPrices.filter(dailyPrice => !dates.has(dailyPrice.date))
      );
      dispatch(fetchDailyPricesSuccess({ dailyPrices: mergedPrices }));
    })
    .catch(e => {
      storableError(e);
    });
};

export const fetchListingUsgs = siteCode => dispatch => {
  dispatch(fetchListingUsgsRequest());

  return getListingUsgs({ siteCode })
    .then(response => {
      return dispatch(fetchListingUsgsSuccess(response));
    })
    .catch(error => dispatch(fetchListingUsgsError(storableError(error))));
};

export const fetchWeatherData = (geolocation, listingId) => dispatch => {
  dispatch(fetchWeatherDataRequest());

  return getListingWeather({ geolocation, listingId })
    .then(response => dispatch(fetchWeatherDataSuccess(response.data)))
    .catch(error => dispatch(fetchWeatherDataError(storableError(error))));
};

export const showListing = (listingId, config, isOwn = false) => (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(data => {
      try {
        const { siteCode, weatherData } = data.data.data.attributes?.publicData;
        const geolocation = data.data.data.attributes?.geolocation;

        if (!weatherData || moment().diff(weatherData.lastUpdatedAt, 'days') > 0) {
          dispatch(fetchWeatherData(geolocation, listingId));
        } else {
          dispatch(fetchWeatherDataSuccess(weatherData.forecast));
        }

        const listingFields = config?.listing?.listingFields;
        const sanitizeConfig = { listingFields };

        dispatch(addMarketplaceEntities(data, sanitizeConfig));
        dispatch(fetchListingUsgs(siteCode));

        return data;
      } catch (error) {
        dispatch(showListingError(storableError(e)));
      }
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const loadListingsOfLastBookings = () => (dispatch, getState, sdk) => {
  dispatch(fetchListingsOfLastBookingsRequest());
  return sdk.listings
    .query({
      include: ['images'],
      'fields.image': ['default', 'variants.scaled-medium'],
      'limit.images': 1,
    })
    .then(response => {
      const images = response.data.included;
      const listings = response.data.data;
      const filteredListings = listings.filter(listing => listing.attributes.publicData.homeReview);

      const random = Math.floor(Math.random() * (filteredListings.length - 4));

      const withReviews = listings
        .filter(listing => listing.attributes.publicData.homeReview)
        .slice(random, random + 3);

      const hotProperties = withReviews.map(withReview => {
        const imageId = withReview.relationships.images.data[0].id.uuid;
        const includedImageUrl = images.find(im => im.id.uuid === imageId).attributes.variants[
          'scaled-medium'
        ].url;
        withReview.attributes.publicData.imageUrl = includedImageUrl;
        withReview.attributes.publicData.bestReview = {
          attributes: {
            content: '',
            rating: 5,
          },
        };
        withReview.attributes.publicData.bestReview.attributes.content =
          withReview.attributes.publicData.homeReview;
        withReview.attributes.publicData.bestReview.attributes.rating = 5;

        return { ...withReview };
      });

      dispatch(fetchListingsOfLastBookingsSuccess(hotProperties));
      return hotProperties;
    })
    .catch(e => {
      dispatch(fetchListingsOfLastBookingsError(storableError(e)));
      throw e;
    });
};

export const fetchListingsOfLastBookings = () => (dispatch, _getState, _sdk) => {
  dispatch(fetchListingsOfLastBookingsRequest());
  return getRandomListings({})
    .then(async response => {
      const entities = denormalisedResponseEntities(response);
      const allIncluded = response.data.included;
      response.data.data.forEach(item =>
        item.relationships?.images?.data.forEach(image => {
          image.included = allIncluded.find(includedItem => includedItem.id.uuid === image.id.uuid);
        })
      );
      dispatch(fetchListingsOfLastBookingsSuccess(response.data.data || []));
    })
    .catch(e => {
      dispatch(fetchListingsOfLastBookingsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));
  dispatch(fetchDailyPrices(listingId, start, end));

  const authorId = getState()?.marketplaceData?.entities?.listing[listingId.uuid]?.relationships
    ?.author?.data?.id?.uuid;

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return sdk.timeslots
    .query({ listingId, start, end, ...extraParams })
    .then(timeSlots => {
      return Promise.all([
        dispatch(fetchTimeSlotsSuccess(monthId, timeSlots)),
        dispatch(calendarSlotsRequest(authorId, listingId.uuid, start, end)),
      ]);
    })
    .then(() => {
      dispatch(formatTimeSlots());
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendInquiry = (listing, message) => (dispatch, getState, sdk) => {
  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias;
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const bodyParams = {
    transition: transitions.INQUIRE,
    processAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendInquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendInquiryError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const unitType = attributes?.publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';

    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const next = moment(nextBoundary)
      .add(89, 'days')
      .toDate();
    const next2 = moment(next)
      .add(89, 'days')
      .toDate();
    const next3 = moment(next2)
      .add(89, 'days')
      .toDate();
    const next4 = moment(next3)
      .add(89, 'days')
      .toDate();

    const remaining = 364 - moment(next4).diff(nextBoundary, 'days');
    const next5 = moment(next4)
      .add(remaining, 'days')
      .toDate();

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, next, tz)),
      dispatch(fetchTimeSlots(listing.id, next, next2, tz)),
      dispatch(fetchTimeSlots(listing.id, next2, next3, tz)),
      dispatch(fetchTimeSlots(listing.id, next3, next4, tz)),
      dispatch(fetchTimeSlots(listing.id, next4, next5, tz)),
      dispatch(formatTimeSlots()),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const loadData = (params, search, config) => dispatch => {
  const listingId = new UUID(params.id);

  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null }));

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, config, true));
  }

  return dispatch(showListing(listingId, config)).then(response => {
    const listing = response?.data?.data;
    const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
    dispatch(fetchListingsOfLastBookings());
    if (isBookingProcessAlias(transactionProcessAlias)) {
      // Fetch timeSlots.
      // This can happen parallel to loadData.
      // We are not interested to return them from loadData call.
      dispatch(fetchReviews(listingId));
      fetchMonthlyTimeSlots(dispatch, listing);
      dispatch(formatTimeSlots());
    }
    return response;
  });
};

export const updateBookmark = (liked, listingId, currentUserId, config) => {
  return (dispatch, _getState, _sdk) => {
    dispatch(updateBookmarkRequest());
    onBookmark({ liked, listingId, currentUserId })
      .then(async _res => {
        await dispatch(showListing(listingId, config));
        dispatch(updateBookmarkSuccess());
      })
      .catch(error => {
        dispatch(updateBookmarkError(error));
      });
  };
};
